import { HttpResponse } from '@angular/common/http';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BleDevice } from '@capacitor-community/bluetooth-le';
import { ArrayHelper, ComponentBase, FormHelper, IdHelper, ObjectHelper, StoreHelper } from 'apps/idl/src/helpers';
import { StringHelper } from 'apps/idl/src/helpers/stringHelper';
import { IContact, UserData } from 'apps/idl/src/model';
import { ITerminalInfoModalParams } from 'apps/idl/src/modules/olaqin/components/terminal-info-modal/models/iterminal-info-modal-params';
import { ITerminalInfo } from 'apps/idl/src/modules/olaqin/models/iterminal-info';
import { OlaqinService } from 'apps/idl/src/modules/olaqin/services/olaqin.service';
import { AMCP } from 'apps/idl/src/modules/patients/model/amc-p';
import { AMOP } from 'apps/idl/src/modules/patients/model/amo-p';
import { EPatientDataSource } from 'apps/idl/src/modules/patients/model/epatient-data-source.enum';
import { EUpdateMode } from 'apps/idl/src/modules/patients/model/eupdate-mode.enum';
import { IPatient } from 'apps/idl/src/modules/patients/model/IPatient';
import { CouverturesService } from 'apps/idl/src/modules/patients/services/couvertures.service';
import { PatientsService } from 'apps/idl/src/modules/patients/services/patients.service';
import { ContactsService, PlatformService } from 'apps/idl/src/services/security';
import { CapacitorPluginScePlugin } from 'capacitor-plugin-sce';
import { StatusSCEPlugin } from 'capacitor-plugin-sce/src/interfaces/StatusSCEPlugin';
import { defer, EMPTY, from, iif, Observable, of, Subject, Subscription, throwError } from 'rxjs';
import { catchError, concatMap, delay, filter, map, mergeMap, switchMap, take, takeUntil, tap, timeout } from 'rxjs/operators';
import { ITerminal } from '../../../../../modules/olaqin/models/iterminal';
import { SceService } from '../../../../../modules/sce/services/sce.service';
import { C_PREFIX_TERMINAL } from '../../../../anakin.constants';
import { SceEventService } from '../../../sce4Mobile/sce-event.service';
import { SceStatus } from '../../../sce4Mobile/sce-status';
import { SceFactory } from '../../../sce4Mobile/sceFactory';
import { EDeviceType } from '../../enums/EDeviceType';
import { EModule } from '../../enums/EModule';
import { ETypeLecteur } from '../../enums/ETypeLecteur';
import { PatientMatchingHelper } from '../../helpers/patient-matching.helper';
import { BluetoothService } from '../../services/bluetooth.service';
import { DrawerPopoverService } from '../../services/drawer-popover.service';
import { LecteurStorageService } from '../../services/lecteurStorage.service';
import { LoaderService } from '../../services/loader.service';
import { PanneauService } from '../../services/panneau.service';
import { SnackbarService } from '../../services/snackbar.service';
import {
	PanneauCorrespondancesPatientsComponent
} from '../panneaux/panneau-correspondances-patients/panneau-correspondances-patients.module';
import { PanneauDossierPatientSuccesComponent } from '../panneaux/panneau-dossier-patient-succes/panneau-dossier-patient-succes.component';

@Component({
    selector: 'di-lecture-terminal',
    templateUrl: './lecture-terminal.component.html',
    styleUrls: ['./lecture-terminal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LectureTerminalComponent extends ComponentBase implements OnInit, OnDestroy {
	@ViewChild('cpsInput') cpsInput: ElementRef;

    @Input() public adri = false;
    @Input() public params?: ITerminalInfoModalParams;
    @Input() public patient?: IPatient;

    private lastTerminalId: string = "";
    public readonly terminalId$: Observable<string>;
    public terminal?: ITerminalInfo;
    public canValidate = false;
    public listTerminal: ITerminal[] = [];
    public isReady: boolean = false;

    public terminalError = false;
    public cpsError = false;
    public vitaleError = false;

    public choixPatient = false;

    public assure: IPatient;
    public beneficiaires: IPatient[];
    public selectedPatientSubject = new Subject<IPatient>();
    public selectedPatient$: Observable<IPatient> = this.selectedPatientSubject.asObservable();
    public isSelected: boolean = false;
    public chargementLecteur: boolean = false;

	public demandeCodeCPS : boolean = false;
	public cpsSaisie : string = "";
	public selectionTerminal = false;
	public errorCodeShow : boolean = false;
	public errorCodeMessage : string = "";

	public selectionCorrespondance = false;
	public lecteurName: string;
	private sceStatusSubscription?: Subscription;

    constructor(
        public svcOlaqin: OlaqinService,
        public changeDetector: ChangeDetectorRef,
        public svcDrawerPopover: DrawerPopoverService,
        private svcPatients: PatientsService,
        private svcLoader: LoaderService,
		private svcSCE : SceService, 
        private svcSnackbar: SnackbarService,
		private svcContact: ContactsService,
		private svcApp : PlatformService,
		private svcSceEvent : SceEventService,
		private svcLecteurStorage : LecteurStorageService,
		private svcCouvertures: CouverturesService,
		private svcPanneau: PanneauService,
		private svcBluetooth: BluetoothService,
		private svcPlatform : PlatformService,
    ) {
        super(changeDetector);
    }

		public pluginSce : CapacitorPluginScePlugin;
		

    public ngOnInit() {
		const deviceTypeUser: EDeviceType = this.svcPlatform.getDeviceType();
		this.pluginSce = SceFactory.getSceInstance(deviceTypeUser)
		
		
		this.getListTerminal();
	}

	public override ngOnDestroy() {
		if (UserData.modules.includes(EModule.sce) && this.svcApp.isMobileApp && !this.selectionCorrespondance) {
			if (this.sceStatusSubscription) {
				this.sceStatusSubscription.unsubscribe();
			}
			from(this.pluginSce.getStatus()).pipe(
				switchMap((status: StatusSCEPlugin) => {
				if (status.connected) {
					return from(this.pluginSce.disconnect());
				}
				return EMPTY;
				})
			).subscribe();
		}
		super.ngOnDestroy();
	}

    public getListTerminal(): void {
		this.svcContact.getContact(ContactsService.getContactIdFromUserId(UserData.current._id)).pipe(
			switchMap((contact: IContact | null) => {
					this.svcLoader.showLoader("Récupération des lecteurs disponibles...")
					if (UserData.modules.includes(EModule.sce)) {
							if (!contact?.finess) {
									this.svcSnackbar.showToast(
											"error",
											"bottom center",
											"Le n° FINESS du praticien n'est pas défini.",
											null,
											null,
											null,
											"7000"
									);
									return EMPTY;
							}
							return this.svcSCE.listTerminals(contact.finess, contact.rpps ?? contact.adeli ?? "");
					}
					return this.svcOlaqin.listTerminals();
			}),
			tap((list: ITerminal[]) => {
				this.svcLoader.hideLoader();
				this.listTerminal = list;
				if (UserData.modules.includes(EModule.sce)) {
						const lastUsedTerminal = this.listTerminal.find(terminal => terminal.lastUsed === true);
						if (lastUsedTerminal) {
								this.lastTerminalId = lastUsedTerminal.terminalId;
								this.terminal = lastUsedTerminal
						}
						if (this.lastTerminalId !== '') {
							this.isSelected = true;
							this.onSelectTerminal(this.terminal)
						}
				} else {
						this.svcOlaqin.getLastUsedTerminalId().pipe(
								tap((terminalId: string) => {
										const termId = IdHelper.getGuidFromId(terminalId, C_PREFIX_TERMINAL) || ''
										this.terminal = this.listTerminal.find(term => term.terminalId === termId );
										this.lastTerminalId = this.terminal ? this.terminal.terminalId : "";
									})
						).subscribe(() => {
								if (this.lastTerminalId !== '') {
										this.isSelected = true;
										this.onSelectTerminal(this.terminal)
								}
								this.detectChanges();
						});
						return;
				}
				this.detectChanges();
			}),
			catchError((error) => {
				this.svcLoader.hideLoader();
				return error
			}),	
			takeUntil(this.destroyed$)
		).subscribe();
	}
	

    public isLastTerminal(terminal: ITerminal): boolean {
        return this.lastTerminalId === terminal.terminalId;
    }

    private isTerminalReady(): boolean {
        this.terminalError = false
        this.cpsError = false
        this.vitaleError = false
        return this.terminal?.terminalConnected && this.terminal?.cpsInserted && (this.terminal?.vitaleInserted || this.adri);
    }

    public onReadyLecteur(): void {
		this.chargementLecteur = true;
        this.isReady = true;
        this.detectChanges();

        const terminalInfo$ = StringHelper.isBlank(this.lastTerminalId)
            ? of({} as ITerminalInfo)
            : UserData.modules.includes(EModule.sce) 
				? this.svcSCE.getTerminalInfos(this.terminal)
				: this.svcOlaqin.getTerminalInfos(this.lastTerminalId);

		terminalInfo$.pipe(
			takeUntil(this.destroyed$),
			catchError((error) => {
				const message = "Une erreur est survenue lors du test de presence carte dans le lecteur.";
				this.chargementLecteur = false;
				this.svcOlaqin.setErreurLectureCV(message);
				this.isReady = true;
				this.terminalError = !this.terminal?.terminalConnected;
				this.cpsError = !this.terminal?.cpsInserted;
				this.vitaleError = !this.terminal?.vitaleInserted;
				this.svcSnackbar.showToast(
					"error",
					"bottom center",
					message,
					null, null, null, "5000"
				);
				this.detectChanges();
				return EMPTY;
			}),
			switchMap((terminal: ITerminalInfo) => {
				this.chargementLecteur = false;
				if(terminal){

					this.terminal.terminalConnected = terminal.terminalConnected;
					this.terminal.vitaleInserted = terminal.vitaleInserted;
					this.terminal.cpsInserted = terminal.cpsInserted;
					this.canValidate = this.isTerminalReady();
					this.detectChanges();
	
					if (this.canValidate) {
						if (this.adri) {
							return of(this.terminal).pipe(
								filter((terminal): terminal is ITerminalInfo => !!terminal),
								map((terminal: ITerminalInfo) => {
									return { terminal };
								}),
								switchMap((data) =>
									UserData.modules.includes(EModule.sce)
										? of({ ...data, terminalId: null })
										: this.svcOlaqin.getLastUsedTerminalId().pipe(
											map((terminalId: string) => ({
												...data,
												terminalId: terminalId.replace("term_", "")
											}))
										)
								),
								switchMap((data) => this.svcCouvertures.getPatientSortedCouvertures(this.patient._id).pipe(
									map((paCouvertures: { AMOPs: AMOP[]; AMCPs: AMCP[] }) => ({
										...data,
										AMO: paCouvertures.AMOPs.map((poAMOP: AMOP) => StoreHelper.getCleanedDocument(poAMOP)),
										AMC: paCouvertures.AMCPs.map((poAMCP: AMCP) => StoreHelper.getCleanedDocument(poAMCP))
									}))
								)),
								switchMap((data) => this.svcOlaqin.updatePatientWithADRiOrVitaleAnakin(
									this.patient,
									data.terminalId ?? data.terminal.terminalId,
									EPatientDataSource.ADRi,
									data.terminal.type
								)),
								tap((response: HttpResponse<IPatient | IPatient[]>) => this.svcDrawerPopover.close(response)),
								catchError((erreur: any) => {
									const message = erreur?.error?.message || "Une erreur est survenue lors de l'appel ADRi";
									this.svcOlaqin.setErreurLectureCV(message);
									this.isReady = false;
									this.terminal = undefined;
									this.svcDrawerPopover.close();
									this.svcLoader.hideLoader();
									this.detectChanges();
									return EMPTY;
								})
							);
						} else {
							// Processus de lecture de carte vitale
							const source$ = this.patient 
								? this.svcPatients.getPatient(this.patient._id).pipe(
									tap((patient: IPatient) => {
										this.patient = patient;
									})
								)
								: of(null);
							  
							return source$.pipe(
								tap(() => this.svcLoader.showLoader("Lecture de la carte Vitale en cours...")),
								switchMap(() => {
									return this.svcOlaqin.readVitalCard(this.terminal.terminalId,this.terminal.type);
								}),
								switchMap((patients: IPatient[]) => {
									if(this.patient){
										// Recherche des patients correspondants à la carte Vitale
										const searchedPatients: IPatient[] = this.svcPatients.searchPatient(patients, {
											...ObjectHelper.pick(this.patient, ["birthDate", "firstName", "lastName", "socialNumber"]),
											fullMatch: !!this.patient.updateDate
										});

										// Si le patient correspond à un patient de la CV, on le sélectionne automatiquement
										if (this.patient.updateDate && searchedPatients.length === 1) {
											return of(ArrayHelper.getFirstElement(searchedPatients));
										} 
									}
									
									if(patients.length === 1) {
										return of(ArrayHelper.getFirstElement(patients));
									}else{
										this.choixPatient = true;  // Demander la sélection du patient si plusieurs résultats
										this.svcLoader.hideLoader();
									}

									this.assure = ArrayHelper.getFirstElement(patients.filter(p => p.AMO[0].qualite === "00"));
									this.beneficiaires = patients.filter(p => p.AMO[0].qualite !== "00");
									this.detectChanges();
									return this.selectedPatient$;  // Retourner l'observable de sélection du patient
								}),
								mergeMap((patient: IPatient) => {
									if (!this.patient) {
										this.svcLoader.showLoader("Recherche de dossiers similaires");
										return this.getCorrespondances(patient).pipe(
											switchMap(({patients, mapScorePatients}) => {
												this.svcLoader.hideLoader();
												if (patients.length > 0){
													this.selectionCorrespondance = true;
													this.svcPanneau.open('Lecture carte Vitale', PanneauCorrespondancesPatientsComponent, { patientCV: patient, terminal: this.terminal, correspondancesPatient: patients, createNewPatient: this.createNewPatient, mapScorePatients });
													this.detectChanges();
													return EMPTY; 
												}else{
													this.svcLoader.showLoader("Enregistrement des données");
													return this.createNewPatient(patient).pipe(
														tap((patient: IPatient) => {
															this.svcPanneau.open('Lecture carte Vitale', PanneauDossierPatientSuccesComponent, { patient: patient, nouveauPatient: true });
															this.svcLoader.hideLoader();
														})
													);
												}
											})
										)
									}

									if (this.choixPatient) this.svcLoader.showLoader("Enregistrement des données");
									return this.svcPatients.updatePatientFromCV(this.patient, patient, this.terminal);
								}),
								mergeMap(() => UserData.modules.includes(EModule.sce) ? of(true) : this.svcOlaqin.setLastUsedTerminalId(this.lastTerminalId)),
								tap(() => {
									this.svcDrawerPopover.close();
									this.svcLoader.hideLoader();
									this.detectChanges();
								}),
								catchError((erreur: any) => {
									const message = erreur?.error?.message || "Une erreur est survenue lors de la lecture de la CV et de la CPS";
									if(!this.patient){
										this.svcLoader.hideLoader();
										this.svcPanneau.close();
										this.svcSnackbar.showToast("error", "bottom center", message, null, null, null, "7000");
										return EMPTY;
									}
									this.svcOlaqin.setErreurLectureCV(message);
									this.isReady = false;
									this.terminal = undefined;
									this.svcDrawerPopover.close();
									this.svcLoader.hideLoader();
									this.detectChanges();
									return EMPTY;
								}),
							);
						}
					} else {
						this.terminalError = !this.terminal?.terminalConnected;
						this.cpsError = !this.terminal?.cpsInserted;
						this.vitaleError = !this.terminal?.vitaleInserted;
						return of(null);
					}
				}else{
					this.terminalError = !this.terminal?.terminalConnected;
					this.cpsError = !this.terminal?.cpsInserted;
					this.vitaleError = !this.terminal?.vitaleInserted;
					return of(null);
				}
            })
        ).subscribe();
    }


    public onClose() {
        this.svcDrawerPopover.close();
		this.svcPanneau.close();
    }

    public async onSelectTerminal(terminal?: ITerminal) {
		this.isReady = false;
		this.isSelected = true;
		this.selectionTerminal = false;
		this.chargementLecteur = false;
		if(terminal){
			this.lastTerminalId = terminal.terminalId;
			this.terminal = terminal;
		}
		this.detectChanges()
		const isSce = this.terminal.type === ETypeLecteur.SCE && ((this.terminal.device === EDeviceType.ANDROID && this.svcApp.isAndroid) || (this.terminal.device === EDeviceType.IOS && this.svcApp.isIOS));

		if (!isSce) {
			this.onReadyLecteur();
			return;
		}

		this.svcLoader.showLoader("Recherche du lecteur Bluetooth...");
		this.listenToSceStatus();
		const sceStatus = await this.pluginSce.getStatus()
		iif(() => !sceStatus.connected && !sceStatus.connecting,			
			defer(() => {
				this.svcLoader.showLoader("Connexion avec le SCE Mobile en cours ...");
				console.warn('[COMP] Connexion au SCE en cours...');
				return from(this.pluginSce.connect());
			}),
			defer(() => {
				this.retrySce();
				this.svcLoader.showLoader("Déconnexion du SCE Mobile en cours...");
				console.warn('[COMP] Déconnexion du SCE en cours...');
				return from(this.pluginSce.disconnect());
			})
		).pipe(
			takeUntil(this.destroyed$),
			catchError((err) => {
				this.svcLoader.hideLoader();
				console.error('[COMP] Erreur lors du connectToSCE initial', err);
				this.svcSceEvent.emitStatus('error');
				return EMPTY;
			})
		).subscribe();
	}

	public retrySce(): void {
		this.svcSceEvent.sceDisconnect$.pipe(
			take(1),
			takeUntil(this.destroyed$),
			tap(() => {
				this.svcLoader.showLoader("Connexion avec le SCE Mobile en cours ...")
				console.warn('[COMP] Connexion au SCE en cours...');
			}),
			concatMap(() => from(this.pluginSce.connect())),
			timeout(15000), 
			catchError(error => {
					this.svcLoader.hideLoader();
					this.svcSnackbar.showToast("error", "bottom center", "Erreur lors de la connexion au lecteur, veuillez réessayer.", null, null, null, "6000");
					this.svcDrawerPopover.close();
					this.svcPanneau.close();
					console.error('Timeout: aucune réponse après 15 secondes');
					return of(null); 
				}
			)
		).subscribe();
	}

    public onPatientSelect(patient: IPatient) {
        this.selectedPatientSubject.next(patient);
    }

	public sendCodeCPS(){
		this.pluginSce.setCarrierCode({carrierCode : this.cpsSaisie});
		this.demandeCodeCPS = false;
		this.errorCodeShow = false;
		this.svcLoader.showLoader("Validation du code porteur...");
		this.detectChanges();
	}

	public validateCpsSaisie(){
		this.cpsSaisie = FormHelper.validCPSCode(this.cpsSaisie);
		this.detectChanges();
	}

	private listenToSceStatus() {
		if (this.sceStatusSubscription) {
			this.sceStatusSubscription.unsubscribe();
			this.sceStatusSubscription = undefined;
		}

		this.sceStatusSubscription = this.svcSceEvent.sceStatus$.pipe(
			filter(Boolean),
			takeUntil(this.destroyed$),
			switchMap((sceStatus: SceStatus) => this.handleSceStatus(sceStatus)),
			catchError(err => {
				this.svcLoader.hideLoader();
				if(!this.patient){
					this.isReady = true;
					this.chargementLecteur = false;
					this.detectChanges();
					return EMPTY;
				}
				if (this.selectionTerminal === true) return EMPTY;
				console.error('[COMP] SCE status handling error:', err.message);
				const message = "La connexion au lecteur SCE a échoué. Essayez de redémarrer le lecteur ou de relancer l'application.";
				this.svcOlaqin.setErreurLectureCV(message);
				this.isReady = false;
				this.terminal = undefined;
				this.svcDrawerPopover.close();
				this.detectChanges();
				return EMPTY;
			})
		).subscribe();
	}

	public handleSceStatus(sceStatus: SceStatus): Observable<SceStatus | void> {
		switch (sceStatus.status) {
			case 'waiting-deviceId':
				this.svcSnackbar.showToast("error", "bottom center", "SCE non utilisable pour le moment. Veuillez enregistrer l'appareil dans Paramétrages > Lecteurs.", null, null, null, "6000");
				return throwError(new Error(`Erreur SCE: ${sceStatus.message ?? "Erreur Inconnue"}`));
			case 'connected':
				console.warn('[COMP] Le SCE est prêt.');
				return from(this.pluginSce.getStatus()).pipe(
					delay(2000),
					switchMap((status: StatusSCEPlugin) => {
						if (status.reader_connected) {
							this.svcLoader.hideLoader();
							this.onReadyLecteur();
							this.selectionTerminal = true;
							return of(sceStatus);
						}
						this.svcLoader.showLoader("Recherche du lecteur Bluetooth en cours ...");
						return from(this.svcLecteurStorage.getLecteurName()).pipe(
							concatMap((lecteurName: string) => {
								if (!lecteurName) {
									this.svcLoader.hideLoader();
									this.svcSnackbar.showToast("error", "bottom center", "Aucun lecteur Bluetooth connecté. Veuillez le connecter dans Paramétrages > Lecteurs", null, null, null, "6000");
									this.isReady = true;
									this.chargementLecteur = false;
									this.detectChanges();
									return EMPTY;
								}
								this.lecteurName = lecteurName;
								return from(this.svcBluetooth.scanForLecteur(this.lecteurName));
							}),
							concatMap((device: BleDevice | null) => {
								if (!device) {
									this.svcLoader.hideLoader();
									this.svcSnackbar.showToast("error", "bottom center", "Aucun lecteur Bluetooth détecté. Veuillez soit l'allumer, soit le connecter dans Paramétrages > Lecteurs", null, null, null, "6000");
									this.isReady = true;
									this.chargementLecteur = false;
									this.detectChanges();
									return EMPTY;
								}
								return from(this.pluginSce.connectToDevice({deviceName: this.lecteurName}));
							})
						);
					})
				);
			case 'waiting-lecteur':
				this.svcLoader.showLoader("Recherche du lecteur Bluetooth en cours ...");
				return of(sceStatus);
			case 'error-code':
				console.warn('[COMP] Une erreur a été détectée dans le processus SCE : ' + sceStatus.message);
				this.errorCodeShow = true;
				this.demandeCodeCPS = true;
				this.cpsSaisie = "";
				this.svcLoader.hideLoader();
				this.errorCodeMessage = sceStatus.message;
				this.detectChanges();
				return of(sceStatus)
			case 'error':
				console.warn('[COMP] Une erreur a été détectée dans le processus SCE : ' + sceStatus.message);
				this.svcSnackbar.showToast("error", "bottom center", `Erreur critique avec le lecteur : ${sceStatus.message ?? "Erreur Inconnue"}.`, null, null, null, "6000");
				return throwError(new Error(`Erreur SCE: ${sceStatus.message ?? "Erreur Inconnue"}`));
			case 'waiting-code':
				console.warn('[COMP] Demande du code porteur.');
				this.svcLoader.hideLoader();
				this.demandeCodeCPS = true;
				this.detectChanges();
				return of(sceStatus)
			case 'ready-code':	
				console.warn('[COMP] Code porteur déjà saisi, lancement de la lecture CV ...');
				if (this.adri) {
					this.svcLoader.showLoader("Appel ADRi en cours...");
				} else {
					this.svcLoader.showLoader("Lecture de la carte Vitale en cours...");
				}
				return of(sceStatus);
			case 'ready':
				if (this.selectionTerminal) break;
				console.warn('[COMP] Le lecteur est prêt.');
				return of(sceStatus).pipe(
					delay(2000),
					tap(() => {
						this.svcLoader.hideLoader();
						this.onReadyLecteur();
						this.selectionTerminal = true;
					}),
				);
			case 'warning':
				console.warn('[COMP] Une erreur a été détectée dans le processus SCE : ' + sceStatus.message);
				return of(sceStatus);
		}
		this.detectChanges();
		return of(sceStatus);
	}

	public getCorrespondances(selectedPatient: IPatient): Observable<{ patients: IPatient[], mapScorePatients: Map<string, { pertinence: number, distance: number }> }> {
		return this.svcPatients.getPatients().pipe(
			map((patients) => {
				let mapScorePatients: Map<string, { pertinence: number, distance: number }> = new Map();

				if (patients.length > 0) {
					mapScorePatients = PatientMatchingHelper.calculerPertinencePourListe(patients, selectedPatient);

					const filteredPatients = patients.filter((patient) => {
						const score = mapScorePatients.get(patient._id || '');
						return score && score.pertinence < 6;
					}).sort((a, b) => {
						const scoreA = mapScorePatients.get(a._id || '');
						const scoreB = mapScorePatients.get(b._id || '');

						if (scoreA!.pertinence !== scoreB!.pertinence) {
							return scoreA!.pertinence - scoreB!.pertinence;
						}
						return scoreB!.distance - scoreA!.distance;
					});

					return { patients: filteredPatients, mapScorePatients };
				}

				return { patients: [], mapScorePatients };
			})
		);
	}

	public createNewPatient = (patientCV: IPatient): Observable<IPatient> => {
		return of(this.svcPatients.initializePatient(null, EUpdateMode.carteVitale)).pipe(
			mergeMap((patient) => this.svcPatients.updatePatientFromCV(patient, patientCV, this.terminal)),
			mergeMap((patient) => this.svcPatients.createPatientLinks(patient).pipe(map(() => patient))),
			catchError((error) => {
				this.svcLoader.hideLoader();
				this.svcPanneau.close();
				this.svcSnackbar.showToast(
					"error",
					"bottom center",
					error,
					null,
					null,
					null,
					"7000"
				);
				return EMPTY
			})
		)
	};
}
